import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {postRgaAdditionalDataByDataType} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';

export const setRouteToReturnPartDefaultTab = () =>
        dispatch => {

            dispatch(routerActions.push('/rga/recalled/returned-part?tab=analyst'));

        };

export const updateRgaAnalysisValues = (property, value) => ({
    property,
    type: actions.UPDATE_RGA_RETURNED_ANALYSIS_VALUES,
    value
});

export const updateRgaAdditionalDataTypeValues = (rgaDetails, dataType) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const rgaAdditionaDataBody = {
                rgaDataTypeId: dataType,
                rgaNumber: rgaDetails.rgaNumber,
                rgaUnit: rgaDetails.responsibleUnit
            };
            const additionalDataInfo = await postRgaAdditionalDataByDataType(rgaAdditionaDataBody);

            dispatch({
                additionalDataInfo,
                type: actions.UPDATE_RGA_ADDITIONAL_DATA_INFO
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const updateRgaAdditionalDataTestValues = (dataParameters, testDataSelectedDropDown) => ({
    dataParameters,
    testDataSelectedDropDown,
    type: actions.UPDATE_RGA_ADDITIONAL_DATA_TEST_SELECTED_DOMAIN
});

export const updateRgaAdditionalDataCommentsValues = (item, additionalInfo, value, field) =>
    async dispatch => {

        dispatch({
            field,
            item,
            type: actions.UPDATE_RGA_ADDITIONAL_DATA_COMMENTS,
            value
        });

    };



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/action-creators/returned-part-info-form.js